<div id="vex-splash-screen">
    <div class="wrapper">
        <div class="ball-scale-multiple">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>
